// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","logo":"Footer_logo__GkEml","links":"Footer_links__q2x7d","copy":"Footer_copy__nbk1i"};